(function ($) {
	'use strict';

	class TableOfContents {
		constructor() {
			this.el = document.querySelector('.js-in-page');
			this.list = document.querySelector('.js-in-page-list');
			this.mobileToggle = document.querySelector('.js-in-page-jump');
			this.totalWidth = 0;
			this.init();
		}

		init() {
			if (this.el) {
				this.getChildrenWidth();
				this.registerWaypoints();
				this.chooseDisplay();
				this.removePreload();

				this.mobileToggle.addEventListener('click', () => {
					this.toggleMenu();
				});

				window.addEventListener('resize', () => {
					this.chooseDisplay();
				});
			}
		}

		highlightMenuItem(id) {
			const inPageJumpTrigger = $('.js-in-page-jump-label');
			const inPageList = $('.js-in-page-list');
			const currentClassName = 'in-page__link--active';

			if ('undefined' !== typeof id && '' !== id) {
				const text = inPageList.find('a[href="#' + id + '"]').text();

				inPageList.find(`.${currentClassName}`).removeClass(currentClassName);
				inPageList.find('a[href="#' + id + '"]').addClass(currentClassName);

				if (text !== '') {
					inPageJumpTrigger.text(text);
				} else {
					inPageJumpTrigger.text('Jump To');
				}
			}
		}

		unhighlightMenuItem(id) {
			const inPageJumpTrigger = $('.js-in-page-jump-label');
			const inPageList = $('.js-in-page-list');
			const currentClassName = 'in-page__link--active';

			const activeEl = inPageList.find(`.${currentClassName}`).first();
			const newEl = inPageList.find('a[href="#' + id + '"]').first();

			if (('undefined' !== typeof id && '' !== id) && activeEl[0] === newEl[0]) {
				inPageList.find(`.${currentClassName}`).removeClass(currentClassName);
				inPageJumpTrigger.text('Jump To');
			}
		}

		registerWaypoints() {
			var $section = $('[data-anchor]');
			const $class = this;

			$section.each(function () {
				var id = $(this).attr('id');

				$(this).waypoint({
					handler: function (direction) {
						if ('down' === direction) {
							$class.highlightMenuItem(id);
						}
					},
					offset: '50%',
				});

				$(this).waypoint({
					handler: function (direction) {
						if ('down' === direction) {
							$class.unhighlightMenuItem(id);
						}
					},
					offset: function () {
						return -this.element.clientHeight;
					}
				});

				$(this).waypoint({
					handler: function (direction) {
						if ('up' === direction) {
							$class.highlightMenuItem(id);
						}
					},
					offset: function () {
						return -this.element.clientHeight;
					}
				});

				$(this).waypoint({
					handler: function (direction) {
						if ('up' === direction) {
							$class.unhighlightMenuItem(id);
						}
					},
					offset: 'bottom-in-view',
				});
			});
		}

		removePreload() {
			this.el.classList.remove('in-page--preload');
		}

		getChildrenWidth() {
			// plus 60 to be safe with padding etc.
			this.totalWidth = this.list.offsetWidth ? this.list.offsetWidth + 60 : 0;
		}

		getPageWidth() {
			return window.innerWidth;
		}

		chooseDisplay() {
			if (this.totalWidth > this.getPageWidth()) {
				this.el.classList.add('in-page--mobile');
				this.el.classList.remove('in-page--desktop');
			} else {
				this.el.classList.remove('in-page--mobile');
				this.el.classList.add('in-page--desktop');
			}

			document.documentElement.style.setProperty('--table-of-contents-height', `${this.el.offsetHeight}px`);
		}

		toggleMenu() {
			this.el.classList.toggle('in-page--open');
		}
	}

	$(function () {
		new TableOfContents();
	});
})(jQuery);
